import axios from 'axios';

export const LanguageService = {
  GetLanguagesOfTheProducts: async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/product/languages`,
    );
    return response;
  },
};
